import Header from "../components/Header"
import WalletConnection from "../components/WalletConnection";
const HomePage = () => {
    return(
        <div>
            <Header />
            <WalletConnection />
        </div>
    )
}

export default HomePage;